import React from "react";
import { Image as ImageIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Closed composer: a one-line prompt that opens the full post form when clicked. */
export function ComposerPill({ onOpen }: { onOpen: () => void }) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onOpen}
      className="mb-6 flex w-full items-center justify-between rounded-full border border-gray-200 bg-white px-4 py-2.5 text-left text-gray-500 shadow-sm transition-colors hover:bg-gray-50"
      data-testid="composer-pill"
    >
      <span>{t("feed_whats_on_mind")}</span>
      <ImageIcon className="h-5 w-5 text-gray-400" aria-label={t("feed_photo")} />
    </button>
  );
}
